import React, { Component } from 'react';
import { auth } from '../firebase';
import { List, Card, Button } from "antd";
import {
  Link,
} from 'react-router-dom'


class Dashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
    }

  }
  componentDidMount() {
    auth.onAuthStateChanged((user) => {
      if (user) {
        this.setState({ email: user.email })
      }
    });
  }


  render() {
    return (
      <div>
        <h1>Dashboard</h1>
        <br></br>
        <Card className="cardy" title='Events'>
          <Button className="gutter-box" type="primary" size="large" >
            <Link to='/dashboard/events/'>Manage Events</Link>
          </Button>
          <br />
        </Card>
        <Card className="cardy" title='Projects'>
          <Button className="gutter-box" type="primary" size="large" >
            <Link to='/dashboard/projects/'>Manage Projects</Link>
          </Button>
          <br />
        </Card>
        <Card className="cardy" title='Limited Units'>
          <Button className="gutter-box" type="primary" size="large" >
            <Link to='/dashboard/limited/'>Manage Limited Units</Link>
          </Button>
          <br />
        </Card>
        <br></br>
        {this.state.email == 'cc@cc.cc' ? <Button type="primary" size="large" ><Link to='admin'>admin</Link></Button> : <div />}
      </div>
    );

  }

}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/views/dashboard.js